<div class="flex h-full min-w-0 flex-col items-stretch justify-start space-y-4 overflow-hidden">
    <div class="flex w-full min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex min-w-0 flex-1 flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="goBack()" type="button" class="btn-shout-fab-secondary shrink-0" aria-label="Back">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5"
                    aria-hidden="true">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="flex min-w-0 w-full flex-1 flex-row flex-wrap items-center justify-between gap-x-2 gap-y-2">
                <div class="min-w-0">
                    <div class="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
                        <h1 class="text-base font-semibold text-primary">{{ brief()?.briefTitle || 'Monitoring brief' }}
                        </h1>
                        <p
                            class="m-0 inline-flex items-center rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-secondary">
                            {{ statusText() }}</p>
                    </div>
                    <p class="text-xs text-secondary">Manage Monitoring Brief</p>
                </div>

                <div class="flex flex-row items-center gap-x-2 justify-end">

                    <scr-screening-tabs [tabs]="tabs()" [activeId]="selectedTab()" ariaLabel="Monitoring brief sections"
                        (tabSelect)="selectTab($event)" />

                    <div class="hidden h-8 border border-gray-200 dark:border-gray-700 rounded-md sm:block"></div>

                    <!-- <button type="button" class="btn-shout btn-shout-sm btn-shout-primary shrink-0"
                        (click)="requestAddCreators()">Add Creators</button> -->

                    <button (click)="requestAddCreators()" type="button"
                        class="inline-flex shrink-0 flex-nowrap items-center gap-x-1.5 whitespace-nowrap rounded-md primary-go-button">
                        Add Creators
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="-mr-0.5 size-5">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <line x1="19" x2="19" y1="8" y2="14" />
                            <line x1="22" x2="16" y1="11" y2="11" />
                        </svg>
                    </button>

                </div>
            </div>
        </div>
    </div>

    <div class="flex h-full min-h-0 w-full flex-1 flex-col gap-y-4 overflow-hidden">
        @if (selectedTab() !== 'overview') {
        <dl class="m-0 grid shrink-0 grid-cols-2 overflow-hidden rounded-xl border border-border bg-card shadow-sm lg:grid-cols-4"
            [attr.aria-busy]="loadingState() === 'loading' ? 'true' : null">
            <div class="border-b border-border px-5 py-4 lg:border-b-0 lg:border-r">
                <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Creators</dt>
                <dd class="m-0 mt-2 text-3xl font-extrabold leading-none text-primary">{{ creatorCountLabel() }}</dd>
            </div>
            <div class="border-b border-border px-5 py-4 lg:border-b-0 lg:border-r">
                <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Posts found</dt>
                <dd class="m-0 mt-2 text-3xl font-extrabold leading-none text-primary">{{ postsFoundLabel() }}</dd>
            </div>
            <div class="border-b border-border px-5 py-4 lg:border-b-0 lg:border-r">
                <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Views</dt>
                <dd class="m-0 mt-2 text-3xl font-extrabold leading-none text-primary">{{ viewsLabel() }}</dd>
            </div>
            <div class="px-5 py-4">
                <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Days left</dt>
                <dd class="m-0 mt-2 text-3xl font-extrabold leading-none text-primary">{{ daysLeft() }}</dd>
            </div>
        </dl>
        }

        @if (loadingState() === 'error') {
        <p class="rounded-xl border border-border bg-card p-6 text-sm text-secondary" role="alert">
            We couldn't load this monitoring brief. Try refreshing, or go back and open it again.
        </p>
        } @else if (loadingState() !== 'loaded') {
        <p class="p-6 text-sm text-secondary" role="status">Loading this brief…</p>
        } @else {
        <div role="tabpanel" [id]="'scr-panel-' + selectedTab()" [attr.aria-labelledby]="'scr-tab-' + selectedTab()"
            tabindex="0" class="flex min-h-0 flex-1 flex-col overflow-hidden focus-visible:outline-none">
            @switch (selectedTab()) {
            @case ('overview') {
            <mbtm-mon-overview class="block h-full min-h-0 flex-1 overflow-y-auto" [posts]="resultStats()"
                [creators]="creators()" [campaignStart]="campaignStart()" [postsFound]="postsFound()" (showResults)="selectTab('results')" />
            }
            @case ('brief_management') {
            @if (brief(); as loaded) {
            <mbtm-mon-brief-management class="block h-full min-h-0 flex-1 overflow-hidden" [brief]="loaded" />
            }
            }
            @case ('content') {
            <mbtm-mon-content class="block h-full min-h-0 flex-1 overflow-hidden" />
            }
            @case ('creators') {
            <mbtm-mon-creators class="block h-full min-h-0 flex-1 overflow-hidden"
                [focussedMonitoringBriefId]="briefId() ?? ''" [openPicker]="openCreatorPicker()"
                (pickerOpened)="onCreatorPickerOpened()" (creatorListSetOut)="onCreatorsChanged()" />
            }
            @case ('results') {
            <mbtm-mon-results class="block h-full min-h-0 flex-1 overflow-hidden" [rows]="resultStats()"
                [creators]="creators() ?? []" [briefTitle]="brief()?.briefTitle || 'Monitoring brief'" />
            }
            }
        </div>
        }
    </div>
</div>